/* xDomeAdvancedFilterComponent.js */

"use strict";
const _ = require("lodash");
const AdvancedFilter = require("@gluenetworks/entity_grid_gl").AdvancedFilter;

class xDomeAdvancedFilterComponent extends AdvancedFilter {
    constructor(props) {
        super(props);
    }

    _getFilterFieldsConfig(columnsConfig) {
        const getDataType = (dataType) => {
            const allowedTypes = [
                "string",
                "integer",
                "double",
                "date",
                "time",
                "datetime",
                "boolean",
                "duration",
            ];
            if (allowedTypes.includes(dataType)) {
                return dataType;
            }
            switch (dataType) {
                case "number":
                    return "integer";
                default:
                    return "string";
            }
        };

        const generateFilterItem = ({name, label, dataType, options, validation}) => {
            let normalisedDataType = getDataType(dataType);

            const filterItem = {
                id: name,
                field: name,
                label: label,
                type: normalisedDataType,
                size: 35,
            };
            if (!_.isEmpty(validation)) {
                Object.assign(filterItem, {validation: validation});
            }

            if (dataType === "duration") {
                Object.assign(filterItem, {
                    values: options,
                    input: "number",
                    operators: [
                        "equal",
                        "not_equal",
                        "less",
                        "less_or_equal",
                        "greater",
                        "greater_or_equal",
                        "between",
                        "not_between",
                        "is_empty",
                        "is_not_empty",
                    ],
                });
            }

            if (dataType === "string") {
                Object.assign(filterItem, {
                    values: options,
                    input: "text",
                    operators: [
                        "equal",
                        "not_equal",
                        "begins_with",
                        "not_begins_with",
                        "contains",
                        "not_contains",
                        "ends_with",
                        "not_ends_with",
                        "is_empty",
                        "is_not_empty",
                    ],
                });
            }

            if (dataType === "boolean") {
                Object.assign(filterItem, {
                    operators: ["equal", "is_empty", "is_not_empty"],
                    input: "radio",
                    default_value: true,
                    values: {
                        1: "Yes",
                        0: "No",
                    },
                    valueSetter: function (rule, value) {
                        value = Number(value) || 0;
                        const name = rule.id + "_value_0";
                        rule.$el
                            .find("[name=" + name + '][value="' + value + '"]')
                            .prop("checked", true)
                            .trigger("change");
                    },
                });
            }

            return filterItem;
        };
        return columnsConfig.map(generateFilterItem);
    }
}

module.exports = xDomeAdvancedFilterComponent;
